import React, { useEffect, useState } from "react";
import styles from "./SectionContent.module.css";
import { SectionList } from "./SectionList";
import { SectionDetails } from "./SectionDetails";
import { Resizer2 } from "../../../../../../common/components";

const MIN_RESIZING = 25;
const MAX_RESIZING = 50;

export const SectionContent = ({
	detectedValues,
	launchInProgress = null,
	sections,
	selectedPageId,
	selectedSection,
	onRefreshSections,
	onValidate,
	onUpdateCompliance,
}) => {
	const [selectedCriteria, setSelectedCriteria] = useState(null);
	const [rightPanelWidth, setRightPanelWidth] = useState(37);
	const handleSelectCriteria = (criteria) => setSelectedCriteria(criteria);
	useEffect(() => {
		setSelectedCriteria(null);
	}, [selectedSection]);
	const handleCloseDetails = () => {
		setSelectedCriteria(null);
	};
	const handleUpdateSelectedCriteria = (updatedSelectedCriteria) => {
		setSelectedCriteria(updatedSelectedCriteria);
	};
	const handleResize = (newWidth) => {
		const clamp = (v) => Math.min(MAX_RESIZING, Math.max(MIN_RESIZING, v));
		setRightPanelWidth(clamp(newWidth));
	};
	return (
		<div className={styles.sectionContent} data-criterion-selected={!!selectedCriteria}>
			<div
				className={styles.resizingContent}
				style={(!selectedCriteria && { width: "100%" }) || { flexBasis: `${100 - rightPanelWidth}vw` }}
			>
				<SectionList
					detectedValues={detectedValues}
					launchInProgress={launchInProgress}
					sections={sections}
					selectedCriteria={selectedCriteria}
					selectedSection={selectedSection}
					onSelectCriteria={handleSelectCriteria}
				/>
			</div>
			{!!selectedCriteria && (
				<>
					<Resizer2
						isOnLeft
						active={!!selectedCriteria}
						className={styles.resizer}
						idAddition="right"
						max={MAX_RESIZING}
						min={MIN_RESIZING}
						value={rightPanelWidth}
						onResize={handleResize}
					/>
					<div className={styles.resizingContent} style={{ flexBasis: `${rightPanelWidth}vw` }}>
						<SectionDetails
							criteria={
								selectedCriteria &&
								(detectedValues.find(
									(detectedValue) => detectedValue.fieldUuid === selectedCriteria.id
								) ||
									null)
							}
							launchInProgress={launchInProgress}
							selectedCriteria={selectedCriteria}
							selectedPageId={selectedPageId}
							onClose={handleCloseDetails}
							onRefreshSections={onRefreshSections}
							onUpdateCompliance={onUpdateCompliance}
							onUpdateSelectedCriteria={handleUpdateSelectedCriteria}
							onValidate={onValidate}
						/>
					</div>
				</>
			)}
		</div>
	);
};
